import { render, staticRenderFns } from "./ShortCodes.vue?vue&type=template&id=726e3d76&"
import script from "./ShortCodes.vue?vue&type=script&lang=js&"
export * from "./ShortCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports